import { Box } from "@mui/material";
import React, { useContext } from "react";
import PageHeader from "../../../components/PageHeader";
import SidebarContext from "../../../context/SidebarContext";
import DealList from "./DealList";

export default function AllDeals() {
  const { open } = useContext(SidebarContext);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "96vh",
        margin: "20px",
        marginRight: "0px",
        width: open === true ? "calc(98vw - 240px)" : "calc(98vw - 80px)",
        backgroundColor: "white",
        padding: "20px",
        borderRadius: "12px",
      }}
    >
      <Box sx={{ borderBottom: "1px solid #E5E5E8" }}>
        <PageHeader pageTitle={"All Deals"} />
      </Box>
      <DealList />
    </Box>
  );
}
